export const getAndSetElements = (that) => {
  if (!that?.selectors || typeof that.selectors !== 'function') return;
  const selectors = that.selectors();
  const elements = {};
  Object.entries(selectors).forEach((arr) => {
    const key = arr[0];
    const selector = arr[1];
    elements[key] = document.querySelector(selector);
  });
  that.els = elements;
  return elements;
}

export const getAndSetData = (that) => {
  if (!that?.els?.json || typeof that.els.json !== 'object') return;
  let data = {}
  try {
    data = JSON.parse(that.els.json.innerText);
    that.data = data;
  } catch (error) {
    console.log(`loading component data failed: ${error}`);
  }
  return data;
}